module.exports = __webpack_public_path__ + "static/img/order-btn.d0bd6634.png";